import { useState } from 'react'
import "../styles/Gallery.css";
import chevronLeftIcon from '../images/icons/chevronLeft.png'
import chevronRightIcon from '../images/icons/chevronRight.png'

const Gallery = ({galleryImages}) => {

  const [slideNumber, setSlideNumber] = useState(0)
  const [openModal, setOpenModal] = useState(false)

  const handleOpenModal = (index) => {
    setSlideNumber(index)
    setOpenModal(true)
  }

  // Close Modal
  const handleCloseModal = () => {
    setOpenModal(false)
  }
  
  // Previous Image
  const prevSlide = () => {
    if (!galleryImages?.length) return;
    const newSlideNumber = (slideNumber - 1 + galleryImages.length) % galleryImages.length;
    setSlideNumber(newSlideNumber);
  }

  // Next Image  
  const nextSlide = () => {
    if (!galleryImages?.length) return;
    const newSlideNumber = (slideNumber + 1) % galleryImages.length;
    setSlideNumber(newSlideNumber);
  }

  return (
    <div>

      {openModal && 
        <div className='sliderWrap'>
          <button className="btnClose" onClick={handleCloseModal} aria-label="Close">
            X
          </button>
          <button className="btnPrev" onClick={prevSlide} aria-label="Previous image">
            <img src={chevronLeftIcon} alt="Previous" />
          </button>
          <button className='btnNext' onClick={nextSlide} aria-label="Next image">
            <img src={chevronRightIcon} alt="Next" />
          </button>
          <div className='fullScreenImage'>
            <img src={galleryImages[slideNumber].src} alt={galleryImages[slideNumber].caption} />
            <p className="caption">{galleryImages[slideNumber].caption}</p>
          </div>
        </div>
      }

      <div className='galleryWrap'>
        {
          galleryImages?.map((image, index) => (
            <div
              className='single'
              key={index}
              role="button"
              tabIndex={0}
              onClick={() => handleOpenModal(index)}
              onKeyDown={(e) => e.key === 'Enter' && handleOpenModal(index)}
            >
              <img src={image.src} alt={image.caption} />
            </div>
          ))
        }
      </div>

    </div>
  )
}

export default Gallery
